var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#191C20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 20,
    height: 6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 20,
    height: 6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 20,
    height: 6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9v4m0 6v4M10 6h12M10 16h12M10 26h12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkTask);
export default __webpack_public_path__ + "static/media/work-task.ce9e3fb4902542504b319fd43f560baa.svg";
export { ForwardRef as ReactComponent };